export const UploadIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2665_9996)">
        <path
          d="M36.25 20.7337C35.1167 14.9837 30.0667 10.667 24 10.667C19.1833 10.667 15 13.4003 12.9167 17.4003C7.9 17.9337 4 22.1837 4 27.3337C4 32.8503 8.48333 37.3337 14 37.3337H35.6667C40.2667 37.3337 44 33.6003 44 29.0003C44 24.6003 40.5833 21.0337 36.25 20.7337ZM27.3333 25.667V32.3337H20.6667V25.667H15.6667L23.4167 17.917C23.75 17.5837 24.2667 17.5837 24.6 17.917L32.3333 25.667H27.3333Z"
          fill="#4F71DD"
        />
      </g>
      <defs>
        <clipPath id="clip0_2665_9996">
          <rect width="48" height="48" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
